import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import { useAuthContext } from 'services/authentication/AuthenticationContext';
import { useModal } from 'components/modals/ModalContext';
import FeatureBadge from 'components/billing/FeatureBadge';
import { fetchData } from 'services/api/fetchData';
import { FormTemplateType } from './FormTypes';
import '../../style/scss/modals.scss';

const FormTemplateLibraryModal: React.FC = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { activeFeatures, handleLogout } = useAuthContext();
    const { revealModal, closeModal } = useModal();
    const [formTemplates, setFormTemplates] = useState<FormTemplateType[]>([]);
    const hasExtendedForms = activeFeatures?.includes('forms_extended');

    // Fetch the current form templates
    useEffect(() => {
        const fetchFormTemplates = async () => {
            try {
                const response = await fetchData({
                    apiUrl: 'get_form_template_list',
                    params: { deleted: false },
                    handleLogout
                });

                setFormTemplates(response.results);
            } catch {
                setFormTemplates([]);
            }

            // Reveal the modal
            revealModal();
        };

        fetchFormTemplates();
    }, []);

    // Handle black form click
    const handleBlankFormClick = () => {
        closeModal();
        history.push('/settings/custom-fields/form-builder/form/new');
    };

    // Handle template click
    const handleTemplateClick = (form_template: FormTemplateType) => {
        closeModal();
        history.push(`/settings/custom-fields/form-builder/form/new?template_id=${form_template.id}`);
    };

    return (
        <div className="form-template-library-modal">

            <div className='form-template-library-cards'>
                <div className="library-card blank-form-card" onClick={handleBlankFormClick}>
                    <div className="icon">
                        <FontAwesomeIcon icon={faFile} />
                    </div>
                    <h5>{t('form.form_template_library.blank_form_title')}</h5>

                    <p>{t('form.form_template_library.blank_form_description')}</p>
                </div>
            </div>

            <div className="template-library-section">
                <div className="title">
                    <h5>
                        {t('form.form_template_library.templates_title')}
                    </h5>

                    {!hasExtendedForms && (
                        <FeatureBadge feature='forms_extended' onClick={closeModal} />
                    )}
                </div>

                {formTemplates.length === 0 && (
                    <p>
                        {t('form.form_template_library.no_templates_found')}
                    </p>
                )}

                {formTemplates.length > 0 && (
                    <div className="modal-list">
                        {formTemplates.map((form_template) => (
                            <ul
                                key={form_template.id}
                                className={`list-row ${hasExtendedForms ? 'clickable' : 'locked'}`}
                                style={{ gridTemplateColumns: '3fr 5fr' }}
                                onClick={() => {
                                    // if (hasExtendedForms) {
                                        handleTemplateClick(form_template);
                                    // }
                                }}
                            >
                                <li>
                                    {form_template.name}
                                </li>
                                <li>
                                    {form_template.description}
                                </li>
                            </ul>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default FormTemplateLibraryModal;